import { STEP_FLOWS, STEPS } from './constants';
import { filterArrayItems, removeFromArray } from './util';

export default class stepFlowMainStrategy {
  constructor(primarySteps = [], secondarySteps = [], overrideSteps) {
    this._primarySteps = [...primarySteps];
    this._secondarySteps = [...secondarySteps];
    this._overrideSteps = overrideSteps;
    this._allSteps = [];
  }

  applyFlowSorting(flow, options) {
    let steps;

    switch (flow) {
      case STEP_FLOWS.FULL_PREQUAL_INDIVIDUAL:
        this._primarySteps = removeFromArray(this._primarySteps, STEPS.LOAN_INTENT);
        this._secondarySteps = [];
        break;
      case STEP_FLOWS.FULL_PREQUAL_JOINT:
        this._primarySteps = removeFromArray(this._primarySteps, STEPS.LOAN_INTENT);
        break;
      case STEP_FLOWS.PARTIAL_PREQUAL_INDIVIDUAL:
        this._secondarySteps = [];
        break;
      case STEP_FLOWS.PARTIAL_PREQUAL_JOINT: // no flow changes needed => full joint flow
        break;
      case STEP_FLOWS.SSNUNHAPPY:
        this._primarySteps = [STEPS.SSN];
        this._secondarySteps = [];
        break;
      case STEP_FLOWS.CONTINUE_APP:
        this._primarySteps = [STEPS.CONTINUE_APP];
        this._secondarySteps = [];
        break;
      case STEP_FLOWS.ERROR_LOGGED_IN:
        steps = options.steps;
        this._overrideSteps = true;
        steps.allSteps = filterArrayItems(steps.allSteps, [STEPS.EMAIL, STEPS.PASSWORD]);
        steps.primarySteps = filterArrayItems(steps.primarySteps, [STEPS.EMAIL, STEPS.PASSWORD]);
        steps.secondarySteps = filterArrayItems(steps.secondarySteps, [STEPS.EMAIL, STEPS.PASSWORD]);
        if (!steps.allSteps.includes(STEPS.CONTINUE_APP)) steps.allSteps.push(STEPS.CONTINUE_APP);
        break;
      case STEP_FLOWS.ERROR_LOGGED_OUT:
        steps = options.steps;
        this._overrideSteps = true;
        if (!steps.allSteps.includes(STEPS.CONTINUE_APP)) steps.allSteps.push(STEPS.CONTINUE_APP);
        break;
      default: // steps will show up in secondaryProgressBar
        this._primarySteps = removeFromArray(this._primarySteps, STEPS.LOAN_INTENT);
        this._secondarySteps = [];
        break;
    }

    this._allSteps = [...this._primarySteps, ...this._secondarySteps];
  }

  buildStepContext(options) {
    if (this._overrideSteps) return options.steps;

    return {
      allSteps: this._allSteps,
      primarySteps: this._primarySteps,
      secondarySteps: this._secondarySteps,
    };
  }

  calculateSteps(options = {}, flow) {
    this.applyFlowSorting(flow, options);

    return this.buildStepContext(options);
  }
}

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');